import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { WarrantyServiceEntry } from '@econtractor/types';
import spinnerTitle from 'components/others/spinnerTitle';
import DateTimeDisplay from 'components/dateTime/DateTimeDisplay';
import { UserNameItem } from 'modules/user';

interface TabServiceProps {
    rows: WarrantyServiceEntry[];
    canEdit: boolean;
    busy: boolean;
    onAdd: (text: string) => Promise<boolean>;
}

const TabService = ({ rows, canEdit, busy, onAdd }: TabServiceProps) => {
    const { t } = useTranslation('Warranties');
    const [text, setText] = useState('');
    return (
        <div>
            {canEdit && (
                <div className="mb-3">
                    <Form.Control
                        as="textarea"
                        rows={3}
                        maxLength={1000}
                        aria-label={t('comment')}
                        placeholder={t('comment')}
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        disabled={busy}
                    />
                    <div className="d-flex justify-content-end mt-2">
                        <Button
                            type="button"
                            variant="info"
                            size="sm"
                            disabled={busy || !text.trim()}
                            onClick={async () => {
                                if (await onAdd(text)) setText('');
                            }}
                        >
                            {spinnerTitle(t('addComment'), busy, t('saving'))}
                        </Button>
                    </div>
                </div>
            )}
            {!rows.length && <p className="text-muted">{t('empty')}</p>}
            {rows.map((entry) => (
                <div key={entry.ID} className="border-bottom py-2">
                    <div className="d-flex align-items-start justify-content-between gap-3 mb-2">
                        <div className="min-w-0 flex-grow-1">
                            <UserNameItem
                                smallMode
                                user={{
                                    userName: entry.userName || '—',
                                    userPicture: entry.userPicture || '',
                                }}
                            />
                        </div>
                        <DateTimeDisplay value={Number(entry.createdAt)} />
                    </div>
                    <p className="mb-0 text-break" style={{ whiteSpace: 'pre-wrap' }}>
                        {entry.text}
                    </p>
                </div>
            ))}
        </div>
    );
};

export default TabService;
